/*
 * Recently viewed products (localStorage, no backend).
 * - On PDPs, main-product.liquid outputs a JSON island
 *   (script[data-recently-viewed-product]); this script appends it to the
 *   localStorage list (max 10 entries, current product first, deduped).
 * - Any <recently-viewed-section> renders cards from the stored data,
 *   excluding the product currently being viewed.
 */
(function () {
  const STORAGE_KEY = 'kegret-recently-viewed';

  function readList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 10)));
    } catch (e) {
      /* storage full / private mode: ignore */
    }
  }

  function currentProduct() {
    const island = document.querySelector('script[data-recently-viewed-product]');
    if (!island) return null;
    try {
      return JSON.parse(island.textContent);
    } catch (e) {
      return null;
    }
  }

  function recordCurrentProduct() {
    const product = currentProduct();
    if (!product) return;
    const list = readList().filter((item) => item.url !== product.url);
    list.unshift(product);
    writeList(list);
  }

  class RecentlyViewedSection extends HTMLElement {
    connectedCallback() {
      const product = currentProduct();
      const limit = parseInt(this.dataset.limit, 10) || 5;
      const items = readList()
        .filter((item) => !product || item.url !== product.url)
        .slice(0, limit);
      if (items.length === 0) return;

      const container = this.querySelector('[data-recently-viewed-list]');
      if (!container) return;

      items.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'grid__item';

        const card = document.createElement('a');
        card.href = item.url;
        card.className = 'recently-viewed__card full-unstyled-link';

        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.width = 300;
          img.height = 300;
          img.loading = 'lazy';
          img.className = 'recently-viewed__image';
          card.appendChild(img);
        }

        const title = document.createElement('span');
        title.className = 'recently-viewed__title';
        title.textContent = item.title;
        card.appendChild(title);

        const price = document.createElement('span');
        price.className = 'recently-viewed__price';
        price.textContent = item.price;
        card.appendChild(price);

        li.appendChild(card);
        container.appendChild(li);
      });

      this.classList.remove('hidden');
    }
  }

  customElements.define('recently-viewed-section', RecentlyViewedSection);
  recordCurrentProduct();
})();
